import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_188: DocMigration = {
  maxSchemaVersion: "0.0.188",
  description: "Add Drawings type to sheets now that background sheets have been added",
  apply(json: any) {
    for (const sheetId in json.sheets) {
      const sheet = json.sheets[sheetId];
      if (!sheet.type) {
        sheet.type = "DRAWINGS";
      }
      json.sheets[sheetId] = sheet;
    }
    return json;
  },
};

export default migration_0_0_188;
